'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');

var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);

var _MajorCities = require('./MajorCities.scss');var styles = _interopRequireWildcard(_MajorCities);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Helpers
// Styles
var MajorCities = function (_Component) {_inherits(MajorCities, _Component);function MajorCities() {var _temp, _this, _ret;_classCallCheck(this, MajorCities);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.modifyAssetPath = function () {var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';return path.
      split('/').
      map(function (item) {return item.includes('w_800') ? item + ',f_auto' : item;}).
      join('/');}, _temp), _possibleConstructorReturn(_this, _ret);}MajorCities.prototype.

  renderBlock = function renderBlock(type, city) {var _this2 = this;
    var createLink = function createLink(rooms) {return (
        _react2.default.createElement(_reactRouter.Link, { to: (0, _appendLocale2.default)(_this2.props.locale, '/homes/' + type + '/' + city + '/rooms_' + rooms) },
          rooms + ' ' + _this2.props.translate('rooms')));};

    var listOfLinks = type === 'rent' ?
    _react2.default.createElement('div', { className: styles.roomsWrapper }, createLink(2), createLink(3), createLink(4)) :
    _react2.default.createElement('div', { className: styles.roomsWrapper }, createLink(3), createLink(4), createLink(5));

    return (
      _react2.default.createElement('div', { className: styles.blockWrapper },
        _react2.default.createElement(_reactRouter.Link, {
            to: (0, _appendLocale2.default)(this.props.locale, '/homes/' + type + '/' + city),
            className: styles.typeTitle },

          _react2.default.createElement('span', null, this.props.translate(type)),
          _react2.default.createElement('i', { className: 'icon-back-right' })),

        !this.props.isMobile && listOfLinks));


  };MajorCities.prototype.

  renderMajorCity = function renderMajorCity(city) {var _props =
    this.props,locale = _props.locale,isMobile = _props.isMobile;var
    assetPath = city.asset_path,localisation = city.localisation;
    var cityName = localisation[locale] || localisation.en;
    var cityNameBlock =
    _react2.default.createElement('div', { className: styles.cityName },
      cityName);



    return (
      _react2.default.createElement('div', { className: styles.cityWrapper, key: cityName },
        _react2.default.createElement(_reactRouter.Link, {
            to: (0, _appendLocale2.default)(this.props.locale, '/homes/buy/' + city.name),
            className: styles.cityImage },

          _react2.default.createElement('div', { style: { backgroundImage: 'url(' + this.modifyAssetPath(assetPath) + ')' } }),
          !isMobile && cityNameBlock),

        _react2.default.createElement('div', { className: styles.properties },
          isMobile && cityNameBlock,
          _react2.default.createElement('div', { className: styles.linkByTypes },
            this.renderBlock('buy', city.name),
            this.renderBlock('rent', city.name)))));




  };MajorCities.prototype.

  render = function render() {var _this3 = this;
    return _react2.default.createElement('div', { className: styles.majorWrapper },
      this.props.majorCitiesData && this.props.majorCitiesData.map(function (city) {return _this3.renderMajorCity(city);}));

  };return MajorCities;}(_react.Component);exports.default = MajorCities;


MajorCities.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  majorCitiesData: _propTypes2.default.array.isRequired,
  translate: _propTypes2.default.func.isRequired,
  isMobile: _propTypes2.default.bool.isRequired };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MajorCities/MajorCities.js
// module id = 2701
// module chunks = 0